import { Uuid } from '@common/utils'

export default {
  props: {
    id: {
      type: String,
      default: function () {
        return Uuid(this.$vnode.tag)
      }
    },
    fieldStyle: {
      type: [Object, String]
    },
    fieldClass: {
      type: Array,
      default: () => [
        'block',
        'text-grey-40'
      ]
    },
    label: {
      type: String
    },
    labelStyle: {
      type: [Object, String]
    },
    labelClass: {
      type: Array,
      default: () => ['font-medium']
    },
    optional: {
      type: Boolean,
      default: false
    },
    optionalStyle: {
      type: [Object, String]
    },
    optionalClass: {
      type: [String, Array, Object],
      default: 'text-xs font-lighter italic'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disabledStyle: {
      type: [Object, String]
    },
    disabledClass: {
      type: Object,
      default: function () {
        return {
          field: 'opacity-75 cursor-not-allowed',
          label: '',
          input: 'cursor-not-allowed'
        }
      }
    }
  },

  computed: {
    labelClasses () {
      let labelClassState = ''
      let labelInner = ''

      if (this.$style) {
        labelClassState = this.active
          ? this.$style['label-inner-active']
          : this.$style['label-inner-inactive']

        labelInner = this.$style['label-inner']
      }

      return [...this.labelClass, {
        [labelClassState]: this.innerLabel,
        [labelInner]: this.innerLabel,
        [this.disabledClass.label]: this.disabled
      }]
    },

    optionalMessage () {
      return this.$t('common.formFields.fields.optional')
    }
  }
}
